import { BannerMultipleAddress } from 'shared/components/mutiple-address/banner-multiple-address';
import { StickyBanner } from 'shared/components/sticky-banner';

export const TopbarBanner = () => (
  <StickyBanner>
    <BannerMultipleAddress />
  </StickyBanner>
);
